import * as Yup from 'yup';
import restorePasswordLabels from '../../labels/reset-password';

export const restorePasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(restorePasswordLabels.validation.email.wrongFormat)
    .required(restorePasswordLabels.validation.email.required)
});
